export const MARKET_CONTRACT_LIST_ROUTES = {
  get: '/hlx/contracts',
};

export const MARKET_CONTRACT_DETAIL_ROUTES = {
  get: '/hlx/contracts/{id}',
};

export const MARKET_CONTRACT_SUMMARY_ROUTES = {
  get: '/hlx/contracts/summary',
};

export const MARKET_CONTRACT_SIGN_ROUTES = {
  post: '/hlx/contracts/{id}/sign',
};

export const MARKET_CONTRACT_TERMINATE_ROUTES = {
  post: '/hlx/contracts/{id}/termination-request',
};

export const MARKET_CONTRACT_WITHDRAW_TERMINATION_ROUTES = {
  post: '/hlx/contracts/{id}/termination-request/withdraw',
};
